// import React, { useState, useCallback, useEffect } from "react";
// import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
// import { useSelector, useDispatch } from "react-redux";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../../Action";
// import "./RerouteModalStyles.css";
// import { CreateQAPair } from "../../../API/api";
// import { toast } from "react-toastify";
// import { Input, Tooltip } from "antd";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import ImageResize from "quill-image-resize-module-react";
// import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
// import { filterDomainsForComponent2 } from "../../../utils";
// import MultiSelectCm from "../../MultiSelectCm/MultiSelectCm";
// import Button from "@mui/material/Button";
// import { styled } from "@mui/material/styles";
// import { Tag } from "antd";
// import { CloseCircleOutlined } from "@ant-design/icons";
// import styles from "./createQAStyles.modal.css";

// export default function CmCreateQA() {
//   const [isLoading, isLoaded] = useState(false);
//   const [domain, setDomain] = useState([]);
//   const [question, setQuestion] = useState("");
//   const [answer, setAnswer] = useState("");
//   const [addText, setAddText] = useState('');
//   const [internal, setInternal] = useState(false);
//   const [privacy, setPrivacy] = useState(false);
//   const [attachments, setAttachments] = useState([]);
//   const VisuallyHiddenInput = styled("input")({
//     clip: "rect(0 0 0 0)",
//     clipPath: "inset(50%)",
//     height: 1,
//     overflow: "hidden",
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     whiteSpace: "nowrap",
//     width: 1,
//     // color:'red'
//   });
//   const userState = useSelector((state) => state.user);
//   const successMsg = (message) => {
//     return (
//       <>
//         <span style={{ fontSize: "12px" }}>{message}</span>
//       </>
//     );
//   };
//   const modalState = useSelector((state) => state.domain);
//   const dispatch = useDispatch();
//   const { advanceFilterModalToggle, cmrRefreshPage } = bindActionCreators(Actions, dispatch);
//   const modules = {
//     toolbar: [
//       ["bold", "italic", "underline", "strike", "blockquote"],
//       [{ list: "ordered" }, { list: "bullet" }],
//       ["link", "image"],
//     ],
//     clipboard: {
//       matchVisual: false,
//     },
//     imageResize: {
//       parchment: Quill.import("parchment"),
//       modules: ["Resize", "DisplaySize"],
//     },
//   };
//   const formats = [
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "blockquote",
//     "list",
//     "bullet",
//     "link",
//     "image",
//   ];
//   const onChangeDomain = (val) => {
//     setDomain(val)
//   }
//   const onChangeValues = (val, key) => {
//     if (key === 'question') {
//       setQuestion(val);
//     }
//     if (key === 'answer') {
//       setAnswer(val);
//     }
//     if (key === 'addText') {
//       setAddText(val);
//     }
//   };
//   const getBase64 = (file, cb) => {
//     let reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = function () {
//       cb(reader.result)
//     };
//     reader.onerror = function (error) {
//     };
//   }
//   const attachmentsData = (file) => {
//     getBase64(file, (result) => {
//       var size =
//         file.size / (1024 * 1024) > 1
//           ? file.size / (1024 * 1024) + " mB"
//           : file.size / 1024 + " kB";
//       let data = {
//         caption: "",
//         name: file.name,
//         size: size,
//         type: file.type,
//         src: result,
//         show: 1,
//         isThumbNail: false,
//       };
//       setAttachments([...attachments, data]);
//     })
//   }
//   const createQA = () => {
//     isLoaded(true);
//     let payload = {
//       additionalContext: addText,
//       answer: answer,
//       domain: Array.isArray(domain) ? "" : domain.value,
//       internal: internal,
//       privacy: privacy,
//       question: question,
//       uplodedFiles: attachments
//     }
//     CreateQAPair(payload).then(res => {
//       if (res === undefined) return;
//       if (res.data.success === true || res.data.data !== "") {
//         toast.success(successMsg(res.data.message));
//         advanceFilterModalToggle({ bool: false, value: "" });
//         cmrRefreshPage(1)
//       } else {
//         toast.error(successMsg(res.data.message));
//         advanceFilterModalToggle({ bool: false, value: "" });
//       }
//     })
//   }
//   const isDisabled = (text) => {
//     var regex = /(<([^>]+)>)/ig;
//     var result = text.replace(regex, "");
//     return result;
//   }
//   return (
//     <>

//       <Modal
//         show={modalState.modalState}
//         onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//         // centered={true}
//         size={"xl"}
//         style={{ marginTop: "5%" }}
//       >
//         <ModalHeader
//           className="reroutetitleModal"
//           closeButton
//           closeVariant="white"
//         >
//           <ModalTitle>
//             <h5 className="headingModal">
//               <i
//                 className="fa fa-plus"
//                 style={{ paddingRight: "7px", fontSize: "20px" }}
//               ></i>
//               Create QA Pair
//             </h5>
//           </ModalTitle>
//         </ModalHeader>
//         <ModalBody className="mb-2" style={{ height: "420px", overflow: "auto" }}>
//           <div
//             className="row"
//             style={{
//               paddingLeft: "3.0rem",
//               padding: "1rem",
//               textAlign: "center",
//             }}
//           >
//             <div>
//               <div
//                 style={{
//                   display: "flex",
//                   paddingBlock: "5px",
//                   alignItems: "center",
//                 }}
//               >
//                 <div style={{ width: "20%", textAlign: "start" }}>
//                   <span style={{ fontSize: "14px", fontWeight: "100" }}>
//                     Question *
//                   </span>
//                 </div>
//                 <div
//                   style={{ width: "80%", textAlign: "start", display: "flex" }}
//                 >
//                   <Input
//                     placeholder="Write your question here..."
//                     style={{ width: "100%" }}
//                     value={question}
//                     onChange={(e) => onChangeValues(e.target.value, 'question')}
//                   />
//                 </div>
//               </div>
//               <div
//                 className="mt-2"
//                 style={{ display: "flex", paddingBlock: "5px" }}
//               >
//                 <div style={{ width: "20%", textAlign: "start" }}>
//                   <span style={{ fontSize: "14px", fontWeight: "100" }}>
//                     Domain
//                   </span>
//                 </div>
//                 <div style={{ marginTop: "8px" }}>
//                   <MultiSelectCm
//                     isMulti={false}
//                     value={domain}
//                     onChangeFunc={onChangeDomain}
//                     options={filterDomainsForComponent2(userState.cmTopics)}
//                   />
//                 </div>
//               </div>
//               <div
//                 className="mt-2"
//                 style={{ display: "flex", paddingBlock: "5px" }}
//               >
//                 <div style={{ width: "20%", textAlign: "start" }}>
//                   <span style={{ fontSize: "14px", fontWeight: "100" }}>
//                     Additional Details
//                   </span>
//                 </div>
//                 <div
//                   style={{ width: "80%", textAlign: "start", display: "flex" }}
//                 >
//                   <Input
//                     placeholder="Write additional details..."
//                     style={{ width: "100%" }}
//                     value={addText}
//                     onChange={(e) => onChangeValues(e.target.value, 'addText')}
//                   />
//                 </div>
//               </div>
//               <div
//                 className="mt-2"
//                 style={{ display: "flex", paddingBlock: "5px" }}
//               >
//                 <div style={{ width: "20%", textAlign: "start" }}>
//                   <span style={{ fontSize: "14px", fontWeight: "100" }}>
//                     Answer *
//                   </span>
//                 </div>
//                 <div style={{ width: "80%", textAlign: "start" }}>
//                   <div style={{ height: "135px" }}>
//                     <input type="file" id="actual-btn2" onChange={(e) => attachmentsData(e.target.files[0])} style={{ display: "none" }} name="files" required="" maxsize="500" aria-invalid="true"></input>
//                     <label for="actual-btn2" style={{ position: 'absolute', right: '40px', marginTop: '11px', fontSize: '16px', color: '#434343', fontWeight: 'bold', cursor: "pointer" }}>
//                       <i className="fa fa-paperclip" style={{ fontWeight: 'bold' }} ></i>
//                     </label>
//                     <ReactQuill
//                       theme="snow"
//                       value={answer}
//                       placeholder="Write your answer here..."
//                       style={{ width: "100%", height: "80px" }}
//                       modules={modules}
//                       formats={formats}
//                       onChange={(e) => onChangeValues(e, 'answer')}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div
//                 style={{ display: "flex", paddingBlock: "5px" }}
//               >
//                 <div style={{ width: "20%", textAlign: "start" }}>
//                 </div>
//                 <div style={{ width: "80%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
//                   <span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}><input type="checkbox" checked={internal} onChange={(e) => setInternal(e.target.checked)} />&nbsp;<Tooltip placement="bottom" color="#fff" title={() => (
//                     <span style={{ color: "black", fontSize: "11px" }}>
//                       This QA pair will be visible only to Employees and not to Customers & Partners.
//                     </span>
//                   )}><i className="fa fa-user-times"></i> Internal Only <i className="fa fa-question-circle"></i></Tooltip></span>&nbsp;&nbsp;<span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}><input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} />&nbsp;<Tooltip placement="bottom" color="#fff" title={() => (
//                     <span style={{ color: "black", fontSize: "11px" }}>
//                       This QA pair will be visible only to Seeker who asked the question and to all Experts.
//                     </span>
//                   )}><i className="fa fa-lock"></i> Do not update Vizerto Knowledge Base <i className="fa fa-question-circle"></i></Tooltip></span>
//                 </div>
//               </div>
//               <div
//                 style={{ display: "flex", paddingBlock: "5px", marginTop: "0px", alignItems: 'baseline' }}
//               >
//                 <div style={{ width: "80%", textAlign: "start" }}>
//                   {attachments.length > 0 && attachments.map(obj => {
//                     return (
//                       <Tag closeIcon={<CloseCircleOutlined />} closable onClose={(e) => {
//                         e.preventDefault();
//                         setAttachments(attachments.filter(ob => {
//                           return obj.name !== ob.name;
//                         }))
//                       }}>{obj.name}</Tag>
//                     )
//                   })}
//                 </div>
//                 {!isLoading && <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
//                   <button style={{ fontSize: '14px', border: '1px solid black', backgroundColor: '#fff', color: 'black', borderRadius: '4px', padding: '5px' }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;&nbsp;{question !== "" && isDisabled(answer) !== '' && <button style={{ fontSize: '14px', border: '1px solid var(--light_color_shade)', backgroundColor: 'var(--light_color_shade)', color: '#fff', borderRadius: '4px', padding: '5px' }} onClick={() => createQA()} disabled={question === "" || isDisabled(answer) === ''}>Create</button>}
//                   {(question.length === 0 || isDisabled(answer).length === 0) && <button style={{ fontSize: '14px', border: '1px solid var(--light_color_shade)', backgroundColor: 'var(--light_color_shade)', color: '#fff', borderRadius: '4px', padding: '5px', opacity: '.6' }} onClick={() => createQA()} disabled={true}>Create</button>}
//                 </div>}
//                 {isLoading &&
//                   <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
//                     <button style={{ fontSize: '14px', border: '1px solid green', backgroundColor: 'green', color: '#fff', borderRadius: '4px', padding: '5px' }}>Creating...</button>
//                   </div>
//                 }
//               </div>
//             </div>
//           </div>
//         </ModalBody>
//       </Modal>

//       {/* <Modal
//         show={modalState.modalState}
//         onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//         centered={true}
//         size={"lg"}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={ModalHeader.styles}>
//             <span className="fa fa-plus"></span>
//             &nbsp;&nbsp;Create QA Pair
//           </Modal.Title>
//         </Modal.Header>
//            <Modal.Body>


//            </Modal.Body>
//       </Modal> */}

//     </>
//   );
// }
import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./RerouteModalStyles.css";
import { CreateQAPair } from "../../../API/api";
import { toast } from "react-toastify";
import { Input, Tooltip } from "antd";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import { filterDomainsForComponent2 } from "../../../utils";
import MultiSelectCm from "../../MultiSelectCm/MultiSelectCm";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Tag } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import styles from "./createQAStyles.modal.css";
import { Select } from 'antd';
import './RerouteModalStyles.css';
import internalImag from '../../../Icons/internal.svg'
import TooltipComp from "../../../NewComponent/ToolTip/TooltipComp";
import { Checkbox } from 'antd';
// import internal from '../../Icons/internal.svg'
// import Style from './RerouteModalStyles';
const containerStyles = {
 borderColor: '#E0E2E6',
 boxShadow: '0px 1px 2px 0px #1018280D',
 color: '#5C667B !important',
 zIndex: '0',
 width: "100%"
}
const textStyles = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "24px",
 fontWeight: "500",
 wordBreak: 'break-word', overflowWrap: 'break-word',
};
const textStyles1 = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "24px",
 fontWeight: "500",
 wordBreak: 'break-word', overflowWrap: 'break-word',
 paddingTop: "10px",
 paddingRight: "5px"


};
const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

export default function CmCreateQA() {
  const [isLoading, isLoaded] = useState(false);
  const [domain, setDomain] = useState([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [addText, setAddText] = useState('');
  const [internal, setInternal] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
    // color:'red'
  });
  const userState = useSelector((state) => state.user);
  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const modalState = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, cmrRefreshPage } = bindActionCreators(Actions, dispatch);
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
    clipboard: {
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };
  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];
  const onChangeDomain = (val) => {
    setDomain(val)
  }
  const onChangeValues = (val, key) => {
    if (key === 'question') {
      setQuestion(val);
    }
    if (key === 'answer') {
      setAnswer(val);
    }
    if (key === 'addText') {
      setAddText(val);
    }
  };
  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result)
    };
    reader.onerror = function (error) {
    };
  }
  const attachmentsData = (file) => {
    getBase64(file, (result) => {
      var size =
        file.size / (1024 * 1024) > 1
          ? file.size / (1024 * 1024) + " mB"
          : file.size / 1024 + " kB";
      let data = {
        caption: "",
        name: file.name,
        size: size,
        type: file.type,
        src: result,
        show: 1,
        isThumbNail: false,
      };
      setAttachments([...attachments, data]);
    })
  }
  const createQA = () => {
    isLoaded(true);
    let payload = {
      additionalContext: addText,
      answer: answer,
      domain: Array.isArray(domain) ? "" : domain.value,
      internal: internal,
      privacy: privacy,
      question: question,
      uplodedFiles: attachments
    }
    CreateQAPair(payload).then(res => {
      if (res === undefined) return;
      if (res.data.success === true || res.data.data !== "") {
        toast.success(successMsg(res.data.message));
        advanceFilterModalToggle({ bool: false, value: "" });
        cmrRefreshPage(1)
      } else {
        toast.error(successMsg(res.data.message));
        advanceFilterModalToggle({ bool: false, value: "" });
      }
    })
  }
  const isDisabled = (text) => {
    var regex = /(<([^>]+)>)/ig;
    var result = text.replace(regex, "");
    return result;
  }
  return (
    <>
 
 
      {/* <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        // centered={true}
        size={"xl"}
        style={{ marginTop: "5%" }}
      >
        <ModalHeader
          className="reroutetitleModal"
          closeButton
          closeVariant="white"
        >
          <ModalTitle>
            <h5 className="headingModal">
              <i
                className="fa fa-plus"
                style={{ paddingRight: "7px", fontSize: "20px" }}
              ></i>
              Create QA Pair
            </h5>
          </ModalTitle>
        </ModalHeader>
        <ModalBody className="mb-2" style={{ height: "420px", overflow: "auto" }}>
          <div
            className="row"
            style={{
              paddingLeft: "3.0rem",
              padding: "1rem",
              textAlign: "center",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  paddingBlock: "5px",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "20%", textAlign: "start" }}>
                  <span style={{ fontSize: "14px", fontWeight: "100" }}>
                    Question *
                  </span>
                </div>
                <div
                  style={{ width: "80%", textAlign: "start", display: "flex" }}
                >
                  <Input
                    placeholder="Write your question here..."
                    style={{ width: "100%" }}
                    value={question}
                    onChange={(e) => onChangeValues(e.target.value, 'question')}
                  />
                </div>
              </div>
              <div
                className="mt-2"
                style={{ display: "flex", paddingBlock: "5px" }}
              >
                <div style={{ width: "20%", textAlign: "start" }}>
                  <span style={{ fontSize: "14px", fontWeight: "100" }}>
                    Domain
                  </span>
                </div>
                <div style={{ marginTop: "8px" }}>
                  <MultiSelectCm
                    isMulti={false}
                    value={domain}
                    onChangeFunc={onChangeDomain}
                    options={filterDomainsForComponent2(userState.cmTopics)}
                  />
                </div>
              </div>
              <div
                className="mt-2"
                style={{ display: "flex", paddingBlock: "5px" }}
              >
                <div style={{ width: "20%", textAlign: "start" }}>
                  <span style={{ fontSize: "14px", fontWeight: "100" }}>
                    Additional Details
                  </span>
                </div>
                <div
                  style={{ width: "80%", textAlign: "start", display: "flex" }}
                >
                  <Input
                    placeholder="Write additional details..."
                    style={{ width: "100%" }}
                    value={addText}
                    onChange={(e) => onChangeValues(e.target.value, 'addText')}
                  />
                </div>
              </div>
              <div
                className="mt-2"
                style={{ display: "flex", paddingBlock: "5px" }}
              >
                <div style={{ width: "20%", textAlign: "start" }}>
                  <span style={{ fontSize: "14px", fontWeight: "100" }}>
                    Answer *
                  </span>
                </div>
                <div style={{ width: "80%", textAlign: "start" }}>
                  <div style={{ height: "135px" }}>
                    <input type="file" id="actual-btn2" onChange={(e) => attachmentsData(e.target.files[0])} style={{ display: "none" }} name="files" required="" maxsize="500" aria-invalid="true"></input>
                    <label for="actual-btn2" style={{ position: 'absolute', right: '40px', marginTop: '11px', fontSize: '16px', color: '#434343', fontWeight: 'bold', cursor: "pointer" }}>
                      <i className="fa fa-paperclip" style={{ fontWeight: 'bold' }} ></i>
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={answer}
                      placeholder="Write your answer here..."
                      style={{ width: "100%", height: "80px" }}
                      modules={modules}
                      formats={formats}
                      onChange={(e) => onChangeValues(e, 'answer')}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ display: "flex", paddingBlock: "5px" }}
              >
                <div style={{ width: "20%", textAlign: "start" }}>
                </div>
                <div style={{ width: "80%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                  <span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}><input type="checkbox" checked={internal} onChange={(e) => setInternal(e.target.checked)} />&nbsp;<Tooltip placement="bottom" color="#fff" title={() => (
                    <span style={{ color: "black", fontSize: "11px" }}>
                      This QA pair will be visible only to Employees and not to Customers & Partners.
                    </span>
                  )}><i className="fa fa-user-times"></i> Internal Only <i className="fa fa-question-circle"></i></Tooltip></span>&nbsp;&nbsp;<span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}><input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} />&nbsp;<Tooltip placement="bottom" color="#fff" title={() => (
                    <span style={{ color: "black", fontSize: "11px" }}>
                      This QA pair will be visible only to Seeker who asked the question and to all Experts.
                    </span>
                  )}><i className="fa fa-lock"></i> Do not update Vizerto Knowledge Base <i className="fa fa-question-circle"></i></Tooltip></span>
                </div>
              </div>
              <div
                style={{ display: "flex", paddingBlock: "5px", marginTop: "0px", alignItems: 'baseline' }}
              >
                <div style={{ width: "80%", textAlign: "start" }}>
                  {attachments.length > 0 && attachments.map(obj => {
                    return (
                      <Tag closeIcon={<CloseCircleOutlined />} closable onClose={(e) => {
                        e.preventDefault();
                        setAttachments(attachments.filter(ob => {
                          return obj.name !== ob.name;
                        }))
                      }}>{obj.name}</Tag>
                    )
                  })}
                </div>
                {!isLoading && <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                  <button style={{ fontSize: '14px', border: '1px solid black', backgroundColor: '#fff', color: 'black', borderRadius: '4px', padding: '5px' }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;&nbsp;{question !== "" && isDisabled(answer) !== '' && <button style={{ fontSize: '14px', border: '1px solid var(--light_color_shade)', backgroundColor: 'var(--light_color_shade)', color: '#fff', borderRadius: '4px', padding: '5px' }} onClick={() => createQA()} disabled={question === "" || isDisabled(answer) === ''}>Create</button>}
                  {(question.length === 0 || isDisabled(answer).length === 0) && <button style={{ fontSize: '14px', border: '1px solid var(--light_color_shade)', backgroundColor: 'var(--light_color_shade)', color: '#fff', borderRadius: '4px', padding: '5px', opacity: '.6' }} onClick={() => createQA()} disabled={true}>Create</button>}
                </div>}
                {isLoading &&
                  <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    <button style={{ fontSize: '14px', border: '1px solid green', backgroundColor: 'green', color: '#fff', borderRadius: '4px', padding: '5px' }}>Creating...</button>
                  </div>
                }
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal> */}
 
 
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        centered={true}
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title style={modalTitleStyle}>
            <span className="fa fa-plus"></span>
            &nbsp;&nbsp;Create QA Pair
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingBottom: "0px", textAlign: 'center', overflowY: 'auto' }}>
          <div>
            <div
              style={{
                display: "flex",
                paddingBlock: "5px",
                alignItems: "center",
              }}
            >
              <div style={{ width: "20%", textAlign: "start" }}>
                <span style={textStyles}>
                  Question*&nbsp;
                </span>
              </div>
              <div
                style={{ width: "80%", textAlign: "start", display: "flex" }}
              >
                <Input
                  placeholder="Write your question here..."
                  // style={{ width: "100%" }}
                  value={question}
                  onChange={(e) => onChangeValues(e.target.value, 'question')}
                  style={containerStyles}
                />
              </div>
            </div>
            <div
              className="mt-2"
              style={{ display: "flex", paddingBlock: "5px", alignItems:"baseline"}}
            >
              <div style={{ width: "20%", textAlign: "start" }}>
                <span style={textStyles}>
                  Domain&nbsp;
                </span>
              </div>
              <div style={{ marginTop: "8px", width: "250px" }}>
                {/* <MultiSelectCm
                  isMulti={false}
                  value={domain}
                  onChangeFunc={onChangeDomain}
                  options={filterDomainsForComponent2(userState.cmTopics)}
                /> */}
 
 
                <Select
                  labelInValue
                  options={filterDomainsForComponent2(userState.cmTopics)}
                  value={domain}
                  onChange={onChangeDomain}
                  placeholder="Select Domain"
                  popupClassName="selectCss"
                  size="middle"
                  style={{
                    width: "100%",
                    border: 'none',
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    fontSize: '16px',
                    textAlign:"left"
                  }}

                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  // style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                />
                {/* <h1 className="heading">color</h1> */}
              </div>
            </div>
            <div
              className="mt-2"
              style={{ display: "flex", paddingBlock: "5px" }}
            >
              <div style={{ width: "20%", textAlign: "start" }}>
                <span style={textStyles}>
                  Additional Details&nbsp;
                </span>
              </div>
              <div
                style={{ width: "80%", textAlign: "start", display: "flex" }}
              >
                <Input
                  placeholder="Write additional details..."
                  style={containerStyles}
                  value={addText}
                  onChange={(e) => onChangeValues(e.target.value, 'addText')}
                />
              </div>
            </div>
            <div
              className="mt-2"
              style={{ display: "flex", paddingBlock: "5px" }}
            >
              <div style={{ width: "20%", textAlign: "start" }}>
                <span style={textStyles}>
                  Answer*&nbsp;
                </span>
              </div>
              <div style={{ width: "80%", textAlign: "start" }}>
                <div style={{ height: "135px" }}>
                  <input type="file" id="actual-btn2" onChange={(e) => attachmentsData(e.target.files[0])} style={{ display: "none" }} name="files" required="" maxsize="500" aria-invalid="true"></input>
                  <label for="actual-btn2" style={{ position: 'absolute', right: '40px', marginTop: '11px', fontSize: '16px', color: '#434343', fontWeight: 'bold', cursor: "pointer" }}>
                    <i className="fa fa-paperclip" style={{ fontWeight: 'bold' }} ></i>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={answer}
                    placeholder="Write your answer here..."
                    style={{ width: "100%", height: "99px" }}
                    modules={modules}
                    formats={formats}
                    onChange={(e) => onChangeValues(e, 'answer')}
                  />
                </div>
              </div>
 
 
            </div>
            <div
              style={{ display: "flex", paddingBlock: "5px" }}
            >
              <div style={{ width: "20%", textAlign: "start" }}>
              </div>
              <div style={{ width: "80%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
 
 
                <div style={textStyles}>
                  <Checkbox onChange={(e) => setInternal(e.target.checked)} checked={internal} type="checkbox" />&nbsp;
                  <img src={internalImag} />&nbsp;Internal Only&nbsp;
                  {/* <span style={textStyles}>
                  Internal Only
              </span> */}
                  {/* <Internal/> */}
                  <TooltipComp title="This QA pair will be visible only to Employees and not to Customers & Partners." >
                    <i className='fa fa-question-circle tooltip-topics-b' ></i>
                  </TooltipComp>
 
 
                </div>&nbsp;&nbsp;&nbsp;&nbsp;
                <div style={textStyles}>
                  <Checkbox  onChange={(e) => setPrivacy(e.target.checked)}  checked={privacy} type="checkbox" />&nbsp;<i className="fa fa-lock"></i>&nbsp;Private Answer&nbsp;
                  <TooltipComp title='This answer will be visible only to the Seeker who asked the question, and to all Experts.'>
                    <i className='fa fa-question-circle tooltip-topics-b'></i>
                  </TooltipComp>
                </div>
 
 
                {/* <span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}>
                  <input type="checkbox" checked={internal} onChange={(e) => setInternal(e.target.checked)} />&nbsp;
                  <Tooltip placement="bottom" color="#fff" title={() => (
                    <span style={{ color: "black", fontSize: "11px" }}>
                      This QA pair will be visible only to Employees and not to Customers & Partners.
                    </span>
                  )}><i className="fa fa-user-times"></i> Internal Only <i className="fa fa-question-circle"></i></Tooltip></span>&nbsp;&nbsp;<span style={{ fontSize: '13px', display: 'flex', justifyContent: 'center' }}>
                    <input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} />&nbsp;<Tooltip placement="bottom" color="#fff" title={() => (
                    <span style={{ color: "black", fontSize: "11px" }}>
                      This QA pair will be visible only to Seeker who asked the question and to all Experts.
                    </span>
                  )}><i className="fa fa-lock"></i> Do not update Vizerto Knowledge Base <i className="fa fa-question-circle"></i></Tooltip>
                  </span> */}
              </div>
            </div>
            <div
              style={{ display: "flex", paddingBlock: "5px", marginTop: "0px", alignItems: 'baseline' }}
            >
              <div style={{ width: "80%", textAlign: "start" }}>
                {attachments.length > 0 && attachments.map(obj => {
                  return (
                    <Tag closeIcon={<CloseCircleOutlined />} closable onClose={(e) => {
                      e.preventDefault();
                      setAttachments(attachments.filter(ob => {
                        return obj.name !== ob.name;
                      }))
                    }}>{obj.name}</Tag>
                  )
                })}
              </div>
              {!isLoading && <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: ' 0px 1px 2px 0px #1018280D',
                    color: '#2A364A',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: " #F6F7F8",
                    marginBottom: '14px',
                    fontWeight: 400,
                    border: " 1px solid #E0E2E6"
 
                    //  font-weight: 400;    
                  }}
                  onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>
                  
                  &nbsp;&nbsp;{question !== "" && isDisabled(answer) !== '' &&
                    <button style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      opacity:question === "" || isDisabled(answer) === ''?"0.7":"",
                      cursor:question === "" || isDisabled(answer) === ''?"not-allowed":"pointer"
                    }} onClick={() => createQA()} disabled={question === "" || isDisabled(answer) === ''}>Create</button>}
                {(question.length === 0 || isDisabled(answer).length === 0) &&
                  <button
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                                  opacity:question === "" || isDisabled(answer) === ''?"0.7":"",
                      cursor:question === "" || isDisabled(answer) === ''?"not-allowed":"pointer"
                    }}
                    onClick={() => createQA()} disabled={true}>Create</button>}
              </div>}
              {isLoading &&
                <div style={{ width: "20%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                  <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    cursor:"not-allowed",
                    opacity:"0.7"
                  }}
                  disabled
                  >Creating...</button>
                </div>
              }
            </div>
 
 
          </div>
 
 
        </Modal.Body>
      </Modal>
 
 
    </>
  );
 }
 